module.exports = __webpack_public_path__ + "img/257.30aaabfe.jpg";